module.exports = __webpack_public_path__ + "static/media/idf.c3a09dfc.svg";